import { Injectable, signal } from '@angular/core';

export type ConsoleArgs = unknown[];

const limit = 1000;

@Injectable({ providedIn: 'root' })
export class ErrorStore {
  private _errors = signal<ConsoleArgs[]>([]);

  public errors = this._errors.asReadonly();

  public pushErrors(data: ConsoleArgs) {
    this._errors.update(current => {
      return [...(current.length > limit ? current.slice(current.length - limit) : current), data];
    })
  }
}
